import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Archive = function Archive(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.494 7.5209c8.096e-4 0.0093095 0.0056667 0.017405 0.0056667 0.026714v11.333c0 0.8929-0.72614 1.619-1.619 1.619h-13.762c-0.8929 0-1.619-0.72614-1.619-1.619v-11.333c0-0.0093095 0.0048571-0.017405 0.0056667-0.026714 0.0048571-0.16271 0.054643-0.3234 0.15624-0.459l2.4286-3.2381c0.1526-0.204 0.39262-0.32381 0.64762-0.32381h10.524c0.255 0 0.49502 0.11981 0.64762 0.32381l2.4286 3.2381c0.1016 0.1356 0.15138 0.29629 0.15624 0.459zm-14.566-0.78281h12.143l-1.2143-1.619h-9.7143l-1.2143 1.619zm2.9264 2.7619c-0.4722 0-0.855 0.3828-0.855 0.855v2.035c0 0.94441 0.76559 1.71 1.71 1.71h4.58c0.94441 0 1.71-0.76559 1.71-1.71v-2.035c0-0.4722-0.3828-0.855-0.855-0.855h-0.067778c-0.4722 0-0.855 0.3828-0.855 0.855v1.645c0 0.27614-0.22386 0.5-0.5 0.5h-3.4444c-0.27614 0-0.5-0.22386-0.5-0.5v-1.645c0-0.4722-0.3828-0.855-0.855-0.855h-0.067778z"
  })));
};

Archive.displayName = 'Archive';
export default Archive;